/* A307c — storewide ex/inc GST toggle. Injected as one asset so the
   layout stays a one-line include. */
(function () {
  var KEY = 'rb-gst-mode';
  var RATE = 1.1;
  // Opens on ex GST (Tommy, 06-08-2026). Anything already stored wins.
  function mode() { try { return localStorage.getItem(KEY) || 'ex'; } catch (e) { return 'ex'; } }
  function setMode(m) { try { localStorage.setItem(KEY, m); } catch (e) {} }

  // The cart is what gets charged — never restate it net of GST.
  //
  // ☠️☠️ A350 — `.atc-banner--container` IS A CART SURFACE AND WAS MISSING.
  // Measured on both stores 12-08-2026: the "just added to your cart" banner
  // lives in its own section, OUTSIDE the cart <form>, so not one selector
  // below reached it and its price was being converted to ex GST — while the
  // cart page one click later showed inc. Same basket, two different numbers,
  // and nothing on screen to say why either was right.
  // ★ The rule this restores: every surface that describes the BASKET quotes
  // the amount charged. Only surfaces that describe a PRODUCT follow the switch.
  function excluded(el) {
    return !!el.closest(
      '.cart, .cart-drawer, #CartDrawer, form[action*="/cart"], ' +
      '.site-header-cart, .totals, .order-summary, .ajaxcart, [data-cart], ' +
      '.atc-banner--container'
    );
  }

  function fmt(n, sample) {
    var s = n.toFixed(2);
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = parts.join('.');
    var cur = (sample.match(/^[^0-9]*/) || [''])[0];
    var tail = (sample.match(/[^0-9]*$/) || [''])[0];
    return cur + out + tail;
  }

  // ☠️☠️ A724 — THE CACHE MUST LEARN A FIGURE THE THEME WRITES OVER IT.
  // Tommy, 17-09-2026, on the Hoshizaki KM-60C-HC: "why is the variants on the
  // front end of website showing the same price????" Shopify held $3,286.35 and
  // $3,675.98 and the dropdown printed both; the big price read $2,987.59
  // whichever was picked. Measured with a MutationObserver on `.price`: Empire's
  // variant change writes "$3,675.98" into the SAME `.money` node, and about a
  // second later this function — finding `data-gst-inc` already set — wrote the
  // remembered "$3,286.35" straight back over it. Every product on CE and CF
  // whose variants differ in price has shown its FIRST variant's price since
  // A307. (A350b measured that `.price` keeps its node identity across a
  // variant change. It does. Nobody measured whether the NUMBER survived.)
  //
  // ★ The rule: a node's text is one of THREE things — the cached inc figure,
  // that figure net of GST, or a NEW figure someone else wrote. Only the third
  // is news, and it is always inc GST (Shopify formats the variant's own
  // price), so it becomes the cached figure before anything is converted.
  // ☠️ NOT "re-read on every tick": in ex mode the node legitimately holds the
  // ex figure, and re-caching THAT would divide it by 1.1 again every 60ms.
  function exOf(incText) {
    var num = parseFloat(incText.replace(/[^0-9.]/g, ''));
    return isFinite(num) ? fmt(num / RATE, incText) : null;
  }

  function convert(root) {
    var ex = mode() === 'ex';
    var nodes = (root || document).querySelectorAll('.money, [data-gst-price]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (excluded(el)) continue;
      var cur = (el.textContent || '').trim();
      var incText = el.getAttribute('data-gst-inc');
      if (incText === null) {
        if (!/\d/.test(cur)) continue;
        el.setAttribute('data-gst-inc', cur);
        incText = cur;
      } else if (cur !== incText && cur !== exOf(incText) && /\d/.test(cur)) {
        // A724 — the theme wrote a new figure. Learn it.
        el.setAttribute('data-gst-inc', cur);
        incText = cur;
      }
      if (!ex) { if (el.textContent !== incText) el.textContent = incText; continue; }
      var want = exOf(incText);
      if (want === null) continue;
      if (el.textContent !== want) el.textContent = want;
    }
    var labels = document.querySelectorAll('[data-gst-label]');
    for (var j = 0; j < labels.length; j++) labels[j].textContent = ex ? 'EX GST' : 'INC GST';
    // The theme prints a fixed "Including GST" note under the product price.
    // Left alone it flatly contradicts the number above it in ex mode.
    //
    // ☠️☠️ A325c — WRITE TO THE SPAN, NEVER TO `.product__tax` ITSELF.
    // The availability line now lives INSIDE this element (right-hand side of
    // the same row), and `el.textContent = '...'` REPLACES EVERY CHILD. Writing
    // to the parent here would delete the stock line the first time anyone
    // flipped the GST switch — and it would come back on the next tick, so it
    // would read as a flicker rather than as this line of code.
    var tax = document.querySelectorAll('.product__tax');
    var taxWord = ex ? 'Excluding GST' : 'Including GST';
    for (var k = 0; k < tax.length; k++) {
      var slot = tax[k].querySelector('[data-rb-taxnote]') || tax[k];
      if (slot.textContent !== taxWord) slot.textContent = taxWord;
    }
    document.documentElement.setAttribute('data-gst-mode', ex ? 'ex' : 'inc');
    paintGstTags(ex);
  }

  // ═══════════════════════════════════════════════════════════════════════
  // A350 — SAY WHICH BASIS THE NUMBER IS ON, BESIDE THE NUMBER
  //
  // Leggatt St Wine Bar, 12-08-2026: "the main page advertises price at $1074,
  // but when I click add to cart, it increases to $1180. Can you please
  // confirm?" Both figures were right — $1,074.41 ex, $1,181.85 inc, on the
  // Thermaster LG-330SC — and NOTHING on the grid card said which was which.
  // The product page had carried "Excluding GST" under the price since A307c;
  // the card and the cart never had anything at all, and a shopper who arrives
  // from Google onto a collection page never sees the product page's note.
  //
  // ★ The switch in the header is not a label. It is 200px away from the price
  // and reads as a control, not as a statement about the number beside it. The
  // qualifier has to sit where the number sits or it does not get read.
  //
  // ★★ CARDS FOLLOW THE SWITCH; CART PRICES NEVER DO. The cart is always the
  // amount charged, so its tag is always "inc GST" whatever the switch says.
  // That asymmetry IS the fix: it turns the 10% step between a card and the
  // cart from an unexplained jump into a labelled one.
  // ═══════════════════════════════════════════════════════════════════════

  // ☠️☠️ THE TAG IS A SIBLING OF THE `.money` NODE, NEVER A CHILD OF IT.
  // convert() caches the inc-GST figure the first time it sees a price, by
  // reading `el.textContent`. A tag nested inside would be cached AS PART OF
  // THE PRICE — "$1,181.85 inc GST" — and every later conversion would parse
  // that string, divide it, and re-append the words to the words. Outside, the
  // cached string stays a price and the tag is free to change independently.
  //
  // ☠️ Direct children only, compared by exact className. `querySelector` would
  // also match a tag belonging to a nested price block, and two hosts would
  // then fight over one span every tick.
  function ownTag(host) {
    for (var i = 0; i < host.children.length; i++) {
      if (host.children[i].className === 'rb-gsttag') return host.children[i];
    }
    return null;
  }

  // ☠️ Create-once, then write-only-on-change. boot()'s MutationObserver watches
  // childList on the whole body, so an unguarded appendChild — or an unguarded
  // textContent assignment — queues a record, which schedules the next tick,
  // which appends again: the permanent DOM loop setText() exists to avoid.
  function tagOn(host, word) {
    if (!host) return;
    var tag = ownTag(host);
    if (!tag) {
      tag = document.createElement('span');
      tag.className = 'rb-gsttag';
      host.appendChild(tag);
    }
    if (tag.textContent !== word) tag.textContent = word;
  }

  // ☠️ `.price__current` and NOT `.productitem__price`. Measured on both stores:
  // the wrapper holds SEVEN children — the visible compare-at, the visible
  // current price, four `--hidden` range variants and a hidden unit price — so
  // appending to the wrapper would drop the tag on its own line below the price
  // instead of beside it. `.price__current` is the visible current price alone;
  // the hidden siblings are classed `price__current--hidden`, which does not
  // carry the `price__current` class, so this selector cannot reach them.
  var CARD_PRICE_HOST = '.productitem__price .price__current';

  // Every surface that quotes the BASKET. Absent ones cost nothing — CF's cart
  // renders none of these until it holds a line, and an empty NodeList is the
  // normal case on most pages.
  var CART_PRICE_HOSTS = [
    '.cart-title-total',            // the running total in the cart header
    '.cart-item--content-price',    // a line's unit price
    '.cart-item--total',            // a line's total
    '.cart-subtotal',               // the subtotal above Check out
    '.atc--product-details--price'  // the "just added to your cart" banner
  ].join(', ');

  function paintGstTags(ex) {
    var word = ex ? 'ex GST' : 'inc GST';
    var cards = document.querySelectorAll(CARD_PRICE_HOST);
    for (var i = 0; i < cards.length; i++) tagOn(cards[i], word);
    var cart = document.querySelectorAll(CART_PRICE_HOSTS);
    for (var j = 0; j < cart.length; j++) tagOn(cart[j], 'inc GST');
    paintCartNote(ex);
  }

  // The one sentence that answers the email. It only exists in ex mode: in inc
  // mode the cart matches everything the shopper has already seen and there is
  // nothing to explain.
  //
  // ☠️ Placed AFTER the theme's own `.cart-message` ("GST included. Shipping
  // calculated at checkout."), never over it — that line is the theme's to
  // write, and rewriting copy we do not own is how the tax note lost the stock
  // line in A325c.
  function paintCartNote(ex) {
    var msg = document.querySelector('.cart-message');
    if (!msg || !msg.parentElement) return;
    var note = msg.parentElement.querySelector('.rb-gstnote');
    if (!ex) {
      // ☠️ Hide, do not remove. Removing and re-creating on every flip of the
      // switch is two childList records per toggle for no visual gain.
      if (note && !note.hidden) note.hidden = true;
      return;
    }
    if (!note) {
      note = document.createElement('p');
      note.className = 'rb-gstnote';
      // ☠️ It does NOT repeat the theme's line above it ("GST included.").
      // The shopper already knows the cart includes GST by the time they read
      // this; what they do not know is why the number moved. Say THAT.
      note.textContent = 'Site prices are shown ex GST. This total includes '
                       + "GST — it's what you'll be charged.";
      msg.parentElement.insertBefore(note, msg.nextSibling);
    }
    if (note.hidden) note.hidden = false;
  }

  function toggle() { setMode(mode() === 'ex' ? 'inc' : 'ex'); convert(); }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gst-toggle]');
    if (!b) return;
    e.preventDefault();
    toggle();
  });

  // The switch belongs in the TOP utility bar beside the socials, with real
  // space between them. Falls back to the header actions if that bar is absent.
  function placeSwitch() {
    // ☠️ Guard on the HOLDER, not on '.gst-switch' — the product page renders
    // its own switch in Liquid, so guarding on the class meant the top-bar
    // one was never added on exactly the pages that matter most.
    if (document.querySelector('.gst-switch-holder')) return;
    var host = document.querySelector('.utility-bar__content-right');
    var wrap = document.createElement('div');
    wrap.className = 'gst-switch-holder';
    wrap.innerHTML = window.__RB_SWITCH__;
    if (host) {
      host.insertBefore(wrap, host.firstChild);
    } else {
      var fallback = document.querySelector('.site-header-actions');
      if (fallback) fallback.insertBefore(wrap, fallback.firstChild);
    }
  }

  // A307i — running order down the column (Tommy, 07-08-2026):
  //   delivery  ->  Add to cart / Add to quote  ->  finance
  // The snippet renders both panels together AFTER the form, so the shipping
  // half has to be lifted above the buy row. Anchored on `.product-form--atc`
  // (the whole qty+buttons group) rather than `.rb-buyhost`, because on CF
  // `.rb-buyhost` is nested INSIDE that group and inserting there would put the
  // panel between the quantity box and the buttons.
  function placePanels() {
    var ship = document.querySelector('[data-rb-ship]');
    var anchor = document.querySelector('.product-form--atc');
    if (!ship || !anchor || !anchor.parentElement) return;
    if (ship.nextElementSibling === anchor) return;   // already in place
    anchor.parentElement.insertBefore(ship, anchor);
  }

  // A325b — the availability line goes on its OWN LINE, directly above the GST
  // switch + ways-to-pay row (Tommy, 10-08-2026: "i like the original
  // Availability: tick and the items in stock line, can you make the same line
  // on the line above the payment methods?").
  //
  // A307i had put it in the right-hand float under the Price Match mark. That
  // float is only ~172px wide, which is why the label and the tick had to be
  // hidden to make it fit. Full width, both come back.
  //
  // The Price Match mark still owns that float, so `.rb-pmp` is still applied —
  // it just holds one child now instead of two.
  //
  // ☠️ Keep walking up past any anchor before choosing the float host. Measured
  // in the rendered HTML of BOTH stores 08-08-2026, the mark is
  //     <div><a href="/pages/best-price-guarantee">
  //            <img class="price_match_logo" ...></a></div>
  // so `logo.parentElement` is the ANCHOR, not the div. Adding the class to the
  // <a> would style the link rather than the block.
  function placeStock() {
    var logo = document.querySelector('.price_match_logo');
    if (logo) {
      var host = logo.parentElement;                  // the div the theme floats
      while (host && host.tagName === 'A') host = host.parentElement;
      if (host) host.classList.add('rb-pmp');
    }
    var stock = document.querySelector('.product-stock-level-wrapper');
    if (!stock) return;

    // ☠️ The theme's tax note is a BARE TEXT NODE. Wrap it once in a span so
    // convert() has something to rewrite that is not the parent — see the
    // matching note there. Needed wherever the stock ends up.
    var tax = document.querySelector('.product__tax');
    if (tax && !tax.querySelector('[data-rb-taxnote]')) {
      var span = document.createElement('span');
      span.setAttribute('data-rb-taxnote', '');
      span.textContent = (tax.textContent || '').trim();
      tax.textContent = '';
      tax.appendChild(span);
    }

    // A332 — Tommy, 11-08-2026, looking at a real phone: availability goes
    // ABOVE the price, on its own left-aligned line.
    //
    // ☠️☠️ A325c had appended it into the "Excluding GST" row with
    // `justify-content: space-between`. On a desktop column those two sit close
    // enough to read as a pair. On a phone that row is the full width of the
    // screen, so it flung "Excluding GST" hard left and "20 in stock" hard
    // right with a void between them — **the identical failure that paired the
    // warehouse chips with the wrong city on 10-08**. `space-between` on a row
    // whose width you do not control is the recurring bug in this panel, not a
    // one-off.
    //
    // ★ Above the price is also the honest order for a $10k considered
    // purchase: whether we HAVE it qualifies what it costs, and if we don't,
    // the discount underneath is beside the point. It gives "Excluding GST"
    // back its own left-aligned line and closes the gap above the GST slider,
    // which is the same complaint from the other end.
    var pricing = document.querySelector('.product-pricing');
    if (pricing && pricing.firstElementChild) {
      // ☠️ Already-in-place guard — without it every tick re-inserts the node,
      // which queues a childList record, which schedules the next tick: a
      // permanent DOM loop.
      if (pricing.firstElementChild !== stock) {
        pricing.insertBefore(stock, pricing.firstElementChild);
      }
      return;
    }

    // Fallback for any page without the theme's tax note: its own line above
    // the pay row, which is where A325b had it.
    var priceline = document.querySelector('.rb-priceline');
    if (!priceline || !priceline.parentElement) return;
    // ☠️ Already-in-place guard. Without it every tick re-inserts the node,
    // which queues a childList record for the observer, which schedules the next
    // tick — the same permanent DOM loop setText() exists to avoid.
    if (stock.nextElementSibling === priceline) return;
    priceline.parentElement.insertBefore(stock, priceline);
  }

  // ═══════════════════════════════════════════════════════════════════════
  // A350b — REO'S PRICE ROW: the price and the switch on line one, the Save
  // badge and the RRP on line two.
  //
  // Tommy, 12-08-2026, holding REO's product page up beside ours: "maybe we
  // need to put the ex gst slider next to the price? ... or we put the RRP
  // pricing and save on a different line and keep the bigger slider". The
  // second reading is what REO actually does, and it is the better one — it
  // frees the whole first line for the price and its switch instead of
  // shrinking the control to fit beside a badge and a struck-out RRP.
  //
  // ★ Why NOT REO's compact single-state chip. The header switch is
  // `display: none` under 767px, so on a phone the product-page switch is the
  // ONLY GST control on the site. A chip that shows just the current state
  // gives a phone shopper nothing to tell them the other state exists. Both
  // halves stay; only the position changes.
  //
  // ★ What this does NOT move: `.price__current`. The theme owns that node and
  // rewrites it on a variant change. Only the switch, the badge and a
  // zero-height break are moved IN, so the theme's own price update path is
  // untouched — and every one of them is re-asserted on the next tick, so a
  // re-render that wipes them heals itself in ~60ms.
  // Measured 12-08-2026 on the Modular Systems Pipe Wallshelf (5 sizes,
  // $96.50-$208.70): `.price` keeps its node identity across a variant change
  // and injected children survive it.
  // ═══════════════════════════════════════════════════════════════════════

  // The product page's own switch, as opposed to the one placeSwitch() puts in
  // the header. Identified by NOT being in the holder, so it stays findable
  // after it has been moved out of `.rb-priceline`.
  function productSwitch() {
    var all = document.querySelectorAll('.gst-switch');
    for (var i = 0; i < all.length; i++) {
      if (!all[i].closest('.gst-switch-holder')) return all[i];
    }
    return null;
  }

  function placePriceRow() {
    var price = document.querySelector('.product-pricing .price.product__price');
    var sw = price ? productSwitch() : null;
    if (price) {
      // ☠️ A full-width zero-height flex item is the only way to force a line
      // break inside a wrapping flex row. Created once; the guard matters
      // because the observer would otherwise see an append every tick.
      if (!price.querySelector('.rb-pricebreak')) {
        var brk = document.createElement('span');
        brk.className = 'rb-pricebreak';
        price.appendChild(brk);
      }
      if (sw && sw.parentElement !== price) price.appendChild(sw);
      // querySelectorAll, not querySelector: a sale product renders the badge
      // once, but leaving a second one stranded outside the row would put it on
      // a line of its own above the price.
      var badges = document.querySelectorAll('.product-pricing .product__badge');
      for (var i = 0; i < badges.length; i++) {
        if (badges[i].parentElement !== price) price.appendChild(badges[i]);
      }
      // ★★ A398 — THE LABEL ENDS THE PRICE LINE, THE MARKS END THE RRP LINE.
      // Tommy, 14-08-2026, with a before/after screenshot: "instead of that do
      // this ... then i will be happy". A397 had given the strip its own row
      // below the price block; this lifts the two halves back onto the price
      // row's own two lines, hard right, at full size.
      //
      // ☠️ IT ONLY FITS BECAUSE `.price` NOW CLEARS THE PRICE MATCH FLOAT.
      // Measured: without `clear: right` the row is 497px of the column's 621px
      // — the float takes 124px — and line 2 has 236px free against the 270px
      // six 40px marks need. Four pixels short of possible. Clearing the float
      // hands back the 124px and the marks fit with ~100px to spare. See the
      // stylesheet for the full sum.
      //
      // ☠️ The two halves are moved SEPARATELY and must never be re-nested.
      // Putting the list back inside the label (or either back inside
      // `.rb-payrow`) makes them one flex item again and pins them to one line.
      //
      // ☠️ Same already-in-place guard as everything else here: a move that
      // runs every tick queues a childList record, which schedules the next
      // tick, for ever.
      var payLabel = document.querySelector('.rb-payrow__label');
      var payList = document.querySelector('.rb-payrow__list');
      if (payLabel && payLabel.parentElement !== price) price.appendChild(payLabel);
      if (payList && payList.parentElement !== price) price.appendChild(payList);
      // ☠️ AND TAKE THE EMPTIED WRAPPER WITH IT. `.rb-priceline:empty` is what
      // closes the gap under the price once everything has been lifted out, and
      // `:empty` counts an empty `<div>` as a child — leave the husk behind and
      // that rule never matches again. We authored `.rb-payrow`, so removing it
      // is ours to do; the children check stops it going on a page where the
      // move has not run.
      var husk = document.querySelector('.rb-payrow');
      if (husk && !husk.children.length) husk.parentElement.removeChild(husk);
    }
    // ☠️ FAIL SAFE. The class is what hides the theme's "Excluding GST" line,
    // and it is set ONLY while the switch really is beside the price. If the
    // move ever fails — a theme update renames `.product__price`, anything —
    // the note comes back rather than the page losing its only GST qualifier.
    // classList.toggle with an explicit force is a no-op when already correct.
    document.documentElement.classList.toggle(
      'rb-gst-inline', !!(price && sw && sw.parentElement === price));
  }

  // The shipping calculator is a third-party app block that lands wherever the
  // theme editor put it. Move it INTO the delivery panel so the two read as one
  // section — and if the app is absent, the panel still stands on its own.
  function fillPanel() {
    var slot = document.querySelector('[data-delivery-calc-slot]');
    if (!slot || slot.getAttribute('data-filled')) return;
    var calc = document.querySelector('.oct-calculator-container, .js--calculator-product-container');
    if (!calc) return;
    slot.appendChild(calc);
    slot.setAttribute('data-filled', '1');
  }

  // ═══════════════════════════════════════════════════════════════════════
  // A316 — the REO-shaped delivery panel: one compact quote line, then the
  // dispatch facts, then a row of SELECTABLE tiles with Standard Kerbside
  // Delivery already chosen.
  //
  // ★★ THE RATE NAMES BELOW ARE MEASURED, NOT GUESSED. Probed 08-08-2026 with
  // Storefront GraphQL `deliveryGroups(first:5, withCarrierRates:true)` against
  // both stores. Everything the two stores actually returned:
  //
  //   CE  'Standard Kerbside Delivery'                    ag_delivery     812.00
  //   CE  'Kerbside Delivery - Cost calculated after
  //        ordering or request a quote'                   quote             0.00
  //   CF  'Standard Door to Door Delivery'                by-weight        21.50
  //   CF  'Kerbside Delivery - Cost calculated after
  //        ordering or request a quote.'                  free-shipping     0.00
  //   CF  (one product returned NO delivery option at all)
  //
  // ☠️☠️ TWO OF THE FOUR ARE ZERO-PRICED PLACEHOLDERS, one of them literally
  // coded `free-shipping`. Rendering their amount would print "$0.00" — a
  // free-delivery claim — on the very panel that exists because "INCLUDED" was
  // being read as a price. A zero is NEVER a price here: it is the absence of
  // one, and it prints as "Calculated after ordering" instead.
  //
  // ☠️ NOT ONE product in that sample returned a premium / in-store rate. So the
  // premium tile must never imply a figure is waiting to be revealed.
  // ═══════════════════════════════════════════════════════════════════════

  // Anything not recognisably premium is the standard service. Kept loose on the
  // premium side and permissive on the standard side, because the measured
  // standard names differ per store ('Kerbside', 'Door to Door') and a new one
  // should degrade to standard rather than vanish.
  var PREM_RE = /premium|in[-\s]?store|inside|white\s*glove|two[-\s]?man|2[-\s]?man/i;
  // The zero-priced placeholders, by the words they actually use.
  var QUOTE_RE = /calculated after|request a quote|quote to confirm/i;

  // ★★ A510 — EXPRESS IS A BUCKET OF ITS OWN, not a second standard.
  //
  // Tommy, 24-08-2026: "if a product on CE ships from our warehouse by Australia
  // Post then it should offer the express post option too." The app now returns
  // TWO AusPost rates for warehouse stock — "Standard Delivery" and "Express
  // Post Delivery" — and scrapeRates keeps the FIRST rate per method, so
  // without this the express row was classed as another standard and dropped on
  // the floor.
  //
  // ☠️ A WHITELIST, deliberately, and not "anything that isn't premium or
  // kerbside". Only warehouse stock has an express service. The other ~7,000
  // products dropship, and the supplier ships when and how they ship — the app's
  // own asr-groups.js suppresses Express across that whole rate table for
  // exactly this reason, after a dropshipped Anvil warmer spent a while
  // advertising "Express Door to Door Delivery $45.00" at checkout. A bucket
  // that catches unknown names would put that back on the page.
  //
  // ☠️ Tested AFTER premium, so a name carrying both words keeps the meaning it
  // has today rather than silently changing tile.
  var EXPR_RE = /express/i;

  // ☠️☠️ A580 — A COLLECTION IS NOT A DELIVERY, AND IT MUST NOT TAKE THE
  // STANDARD BUCKET.
  //
  // Tommy, 28-08-2026, screenshotting a Tormek page with a Brisbane postcode:
  // the Standard tile read "Calculated after ordering" while the real standard
  // rate was $10.46. A579 had just put "Our Warehouse Collection" on that
  // group. It is not premium and not express, so it fell through to `standard`
  // — and Shopify lists the cheapest rate FIRST, so at $0.00 it arrived before
  // the $10.46 and scrapeRates' first-wins rule threw the real price away. The
  // zero then printed as "Calculated after ordering", because A344's saysFree
  // test is the only thing that lets a zero read as free and A576 had just
  // taken the "FREE " prefix off every pickup rate.
  //
  // ★ The fix is a BUCKET, not a wording. A collection is a fourth service, the
  // same way A510 made express a third — and a service nobody can be charged
  // for has no business competing for the tile that shows a price.
  //
  // ☠️ A WHITELIST like EXPR_RE, never "anything that isn't premium". Every
  // collection our app can emit says the word: federalCollect's "<City>
  // Warehouse Collection", warehouseCollect's "Our"/"Roband Warehouse
  // Collection", and the five bromic_collect rules' "Collect - Sydney
  // (Ingleburn, NSW)". A bucket that caught unknown names would pull real
  // delivery services out of the price tiles instead.
  //
  // ☠️ Tested AFTER premium and express, so a name carrying two of the words
  // keeps the meaning it has today rather than silently changing tile.
  //
  // ☠️ DOUBLE the backslash — this JS lives inside a NON-RAW Python string, so
  // a single \b compiles to a literal BACKSPACE and the deployed regex matches
  // nothing. That has shipped once already (see saysFree below). PREM_RE writes
  // `\s` for the same reason, and a test runs this regex to prove which one it
  // compiled to.
  //
  // ★ The collect TILE is untouched by this. It deliberately carries no
  // `data-rb-tprice`, so paintTilePrice() returns early and its static "No
  // charge" cannot be overwritten by the rate this now files.
  var COLLECT_RE = /\bcollect(?:ion)?\b/i;

  function methodOf(name) {
    if (PREM_RE.test(name || '')) return 'premium';
    if (EXPR_RE.test(name || '')) return 'express';
    if (COLLECT_RE.test(name || '')) return 'collect';
    return 'standard';
  }

  // ═══════════════════════════════════════════════════════════════════════
  // ★★ A356 — THE TRANSIT ESTIMATE IS IN THE TITLE, NOT THE DESCRIPTION.
  //
  // Tommy, 13-08-2026: "when the postcode is entered the estimated dispatch
  // time still doesn't show". It was in the page the whole time. Measured live
  // on CE for 4101 on 13-08-2026, the two rows the app returns are:
  //
  //   __title  "Kerbside Delivery (1-4 Business Days from dispatch)"
  //   __desc   "To your kerb, loading bay or dock — not inside your premises.
  //             Delivery time determined by postcode."           $44.00
  //
  //   __title  "Premium In-Store Delivery — SHIPPING NOT INCLUDED, invoiced
  //             after ordering"                                   $0.00
  //
  // A307l printed the DESCRIPTION on the dispatch line, and the description is
  // the half with no estimate in it — it says the delivery time depends on the
  // postcode the shopper has just typed in. The estimate is in the title, which
  // methodOf() reads and then throws away, because the tile shows our own label.
  //
  // ☠️ STILL NEVER ASSEMBLED. This lifts the carrier's own bracketed phrase out
  // WHOLE and prints it as written — same rule as custom.dispatch_estimate,
  // which holds a whole sentence. We do not turn "1-4" into "1 to 4 business
  // days", and we do not add "Delivery in " in front of it.
  //
  // ☠️ Brackets alone are not enough. A title could carry "(excludes WA)" or
  // "(bulky item)", and printing that on a line the shopper reads as a delivery
  // estimate is worse than printing nothing. The phrase must actually name a
  // unit of time, or there is no estimate here and the line falls back.
  // ═══════════════════════════════════════════════════════════════════════
  var TRANSIT_RE = /\(([^()]*\b(?:days?|weeks?|hours?)\b[^()]*)\)/i;

  function transitFrom(name) {
    var m = TRANSIT_RE.exec(name || '');
    return m ? m[1].trim() : '';
  }

  // ☠️ Class names lifted from OUR OWN ecbd-custom.css / e-cbd-custom.css, which
  // already style `.oct-shipping-rate__name` and `.oct-shipping-rate__price` —
  // measured in a stylesheet we ship, not invented. The rows only exist AFTER
  // the shopper runs the calculator, so finding none is the normal case and has
  // to be completely silent.
  function scrapeRates() {
    var out = {};
    var rows = document.querySelectorAll('.oct-shipping-rate');
    for (var i = 0; i < rows.length; i++) {
      var n = rows[i].querySelector('.oct-shipping-rate__name');
      var p = rows[i].querySelector('.oct-shipping-rate__price');
      if (!n) continue;
      // ☠️ A307l — the name node holds TWO children, and only sometimes.
      // Measured 10-08-2026 on both stores:
      //   CE  __title "Kerbside Delivery (1-4 Business Days from dispatch)"
      //     + __description "Delivery time determined by postcode."
      //   CF  __title only, no description node at all.
      // Reading .textContent off the parent glues them into one run-on string.
      // That was harmless while the string was only ever regex-matched, but the
      // dispatch fact line is printed out of these, so the two have to come
      // apart — and since A356 they carry DIFFERENT things: the estimate is in
      // the title, the kerbside caveat is in the description. Glue them back
      // together and transitFrom() starts matching brackets from either.
      // Fall back to the parent when the app renders no __title.
      var tEl = n.querySelector('.oct-shipping-rate__title');
      var dEl = n.querySelector('.oct-shipping-rate__description');
      var name = ((tEl || n).textContent || '').trim();
      var desc = dEl ? (dEl.textContent || '').trim() : '';
      var text = p ? (p.textContent || '').trim() : '';
      var num = parseFloat(text.replace(/[^0-9.]/g, ''));
      var m = methodOf(name);
      if (out[m]) continue;                       // first rate per method wins
      out[m] = {
        name: name,
        desc: desc,
        // A356 — parsed here, beside the scrape it comes from, so paintShip
        // reads a field rather than re-deriving one. Empty on CF, whose title
        // is a bare 'Standard Door to Door Delivery', and empty on the premium
        // row — both correctly print no estimate at all.
        transit: transitFrom(name),
        text: text,
        amount: isFinite(num) ? num : null,
        quoted: QUOTE_RE.test(name) || QUOTE_RE.test(desc) || QUOTE_RE.test(text)
      };
    }
    return out;
  }

  // ── The seam for the OTHER workstream ─────────────────────────────────
  // Whoever wires up a real destination lookup should set
  //     window.__RB_SHIP_RATES__ = {
  //       standard: { text: '$812.00', amount: 812, name: '...' },
  //       premium:  { ... },            // omit entirely when there is no premium rate
  //       eta:      'Delivery in 7-14 Business Days',   // omit if unknown
  //       origin:   'Brisbane, QLD'                     // omit if unknown
  //     }
  // and then dispatch `new CustomEvent('rb:ship')` on document. Everything is
  // optional and anything absent renders as NOTHING — never as a placeholder.
  function shipData() {
    var d = window.__RB_SHIP_RATES__;
    if (d && typeof d === 'object') return d;
    return scrapeRates();
  }

  // ☠️☠️ WRITE-ONLY-ON-CHANGE. paintShip() runs on EVERY tick, and boot()'s
  // MutationObserver watches `childList` on the whole body. Assigning
  // `.textContent` ALWAYS replaces the node's children — even when the string is
  // identical — so an unguarded write queues a childList record, which schedules
  // the next tick, which writes again: a permanent ~60ms DOM loop on every
  // product page, burning phone battery for no visual change.
  // convert() above has always guarded this way (`if (el.textContent !== want)`);
  // paintShip must too. Never assign textContent here without this.
  function setText(el, s) {
    if (el && el.textContent !== s) el.textContent = s;
  }

  // Same write-only-on-change discipline as setText: paintShip runs on every
  // tick, and an unguarded `hidden` assignment on an already-correct node still
  // queues an attribute record for the observer.
  function togglePart(panel, key, on) {
    var el = panel.querySelector('[data-rb-part="' + key + '"]');
    if (el && el.hidden === on) el.hidden = !on;
  }

  function paintShip() {
    var panel = document.querySelector('[data-rb-ship]');
    if (!panel) return;
    var sel = panel.getAttribute('data-rb-method') || 'standard';
    var data = shipData() || {};
    var rate = data[sel];

    // ☠️☠️ A307k — Tommy, 10-08-2026: "only some suppliers offer premium shipping
    // rates that show at checkout, most requires a quote."
    //
    // THREE STATES, not two, and the difference between the last two is the
    // whole bug this fixes:
    //   unknown  the shopper has not resolved a destination yet, so the
    //            calculator has rendered no rows and we know NOTHING.
    //   priced   a rate came back for the selected service. Show it.
    //   quoted   rates came back and this service was NOT among them. That is
    //            the COMMON case for premium, and it used to render as an
    //            EMPTY price. Blank beside the calculator's own visible
    //            "Kerbside Delivery $198.00" reads as "premium is $198 too".
    //            Silence is not neutral here — it inherits the number above it.
    // A510 — express counts as "we have read the rates" too. In practice the
    // standard rate always comes with it (the warehouse group's standard rule is
    // unconditional), but reading `known` off a subset of the buckets is the
    // kind of thing that quietly stops being true.
    var known = !!(data.standard || data.premium || data.express);

    // ☠️ A325d — repaint the branch rows FIRST. paintCollect() reads its
    // quantities back off those rows, so painting in the other order would
    // decide collection from the previously selected variant's stock.
    paintWarehouse();

    // ☠️☠️ A325 — the collect tile can VANISH under the shopper. They pick
    // "Collect from Stapylton", then change the postcode to Perth. If the
    // selection were left pointing at a tile that is now hidden, the panel would
    // show no selected service at all and the detail line would describe a
    // collection that is no longer on offer. Fall back to standard the moment
    // it stops being available.
    var collectCode = paintCollect(panel, data);
    if (sel === 'collect' && !collectCode) {
      sel = 'standard';
      panel.setAttribute('data-rb-method', sel);
      rate = data[sel];
    }

    // ☠️ A510 — and the express tile can vanish the same way. Pick Express on a
    // warehouse item, then change to a cart or a postcode AusPost cannot carry
    // (over 22 kg, over 105 cm) and there is no express rate to select any more.
    // Same fall back to standard, for the same reason: a selection pointing at a
    // hidden tile leaves the panel showing no chosen service at all.
    var hasExpress = paintExpress(panel, data);
    if (sel === 'express' && !hasExpress) {
      sel = 'standard';
      panel.setAttribute('data-rb-method', sel);
      rate = data[sel];
    }

    // ☠️ A307l — hide the app's own rate list ONLY once we have actually read it.
    // Set from `known`, so the moment scrapeRates() comes back empty — a class
    // rename, a re-render, anything — the app's prices come straight back into
    // view. The panel can be redundant; it can never be priceless.
    panel.classList.toggle('rb-ship--scraped', known);

    // The tiles: selection state is the whole message. No chip, no "INCLUDED".
    var tiles = panel.querySelectorAll('[data-rb-tile]');
    for (var i = 0; i < tiles.length; i++) {
      var on = tiles[i].getAttribute('data-rb-tile') === sel;
      tiles[i].classList.toggle('is-on', on);
      tiles[i].setAttribute('aria-checked', on ? 'true' : 'false');
      tiles[i].tabIndex = on ? 0 : -1;
      var wasFree = paintTilePrice(
        tiles[i], data[tiles[i].getAttribute('data-rb-tile')], known);
      // ★★ A392 — THE PILL BY THE PRICE IS A MIRROR, NEVER A SECOND OPINION.
      // It is handed the verdict paintTilePrice just reached for the STANDARD
      // tile and has no rule of its own. Tommy, 14-08-2026, choosing between
      // three ways to do this: it may only appear "once the postcode confirms
      // it". Anything that decided for itself would be a fourth chance to
      // repeat A330 / A333 / A344 — three separate occasions when a zero was
      // read as free and we advertised freight we then invoiced.
      if (tiles[i].getAttribute('data-rb-tile') === 'standard') {
        placeFreePill(wasFree);
      }
    }
    var dets = panel.querySelectorAll('[data-rb-detail]');
    for (var j = 0; j < dets.length; j++) {
      var show = dets[j].getAttribute('data-rb-detail') === sel;
      dets[j].hidden = !show;
    }

    // A307k — the detail line under the tiles has to agree with the tile prices.
    // A premium rate only counts as PRICED when it is a real, non-zero
    // amount; a `quote` / `free-shipping` placeholder is a quote, not a price.
    // ★ When we know nothing yet, we show the QUOTE wording, because Tommy's
    // fact is that most items need one. Leaning the other way would promise a
    // figure that usually never arrives.
    var prem = data.premium;
    var premPriced = !!(prem && !prem.quoted && prem.amount);
    togglePart(panel, 'prem-priced', premPriced);
    togglePart(panel, 'prem-quote', !premPriced);

    // The two fact lines. They print ONLY when the data really exists — the
    // same discipline the W x D x H card line uses. No invented transit times,
    // no invented warehouse.
    //
    // ★ A307l — the selected rate's OWN description is now a source for the
    // dispatch line. Hiding the app's list would otherwise have thrown away
    // "Delivery time determined by postcode.", which CE prints and CF does not.
    // ☠️ It is passed through VERBATIM and never assembled from parts: the rule
    // that dispatch_estimate holds a whole sentence applies just as hard to a
    // sentence the carrier wrote. A metafield still wins (setFact leaves anything
    // Liquid printed alone).
    //
    // ★★ A356 — the carrier's own transit phrase now OUTRANKS its description.
    // Both come from the same rate, so this is not a new source of truth; it is
    // choosing the half that answers the question the shopper asked by typing a
    // postcode. On CE the description's other half ("To your kerb, loading bay
    // or dock") is already printed as the tile's own subtitle two lines down, so
    // nothing is lost by preferring the estimate — a duplicate line goes with it.
    // ☠️ The order is deliberate: a real metafield still beats both, and an
    // absent estimate still falls through to the description rather than
    // blanking a line that used to say something.
    // ☠️☠️ A587 — and NOT on a collection, which has its own paragraph below.
    // The decision moved into etaFor() so it can be run in a test; the reasoning
    // lives there.
    setFact(panel, 'eta', etaFor(sel, data, rate));
    // ★★ A325f — "we need a little text somewhere saying Dispatched from
    // Sydney, NSW" (Tommy, 10-08). The slot and the `!= blank` discipline were
    // already here for the custom.dispatch_origin metafield; what was missing
    // was anything to put in it. Now computed from real per-branch stock plus
    // the destination, and it prints the CAPITAL, matching the tiles.
    // ☠️ An empty string means "we cannot say", and setFact renders nothing —
    // never a default, never "probably Sydney".
    var dcode = dispatchBranch();
    var dbranch = dcode ? RB_BRANCHES[dcode] : null;
    setFact(panel, 'origin', data.origin || (dbranch ? dbranch.capital : ''));
  }

  // ═══════════════════════════════════════════════════════════════════════
  // A325 — WAREHOUSE COLLECTION
  //
  // Offered only when BOTH hold:
  //   1. a branch actually has stock of THIS product (from the metafield the
  //      FED card writes, read back off the rendered rows), and
  //   2. the shopper's postcode is inside that branch's metro band.
  //
  // ☠️ Both halves are required. Stock alone would offer a Perth shopper a
  // collection from Moorebank; postcode alone would offer a collection of
  // something that isn't there.
  // ═══════════════════════════════════════════════════════════════════════
  var RB_BRANCHES = {"NSW":{"capital":"Sydney, NSW","city":"Sydney","suburb":"Moorebank, NSW","address":"3B Tiber Place, Moorebank NSW 2170","hours":"Mon-Fri 9:00am-5:00pm"},"VIC":{"capital":"Melbourne, VIC","city":"Melbourne","suburb":"Truganina, VIC","address":"1 Efficient Drive, Truganina VIC 3029","hours":"Mon-Fri 9:00am-5:00pm"},"QLD":{"capital":"Brisbane, QLD","city":"Brisbane","suburb":"Stapylton, QLD","address":"17 Homestead Drive, Stapylton QLD 4207","hours":"Mon-Fri 8:00am-4:00pm"},"SA":{"capital":"Adelaide, SA","city":"Adelaide","suburb":"Wingfield, SA","address":"382 Hanson Road, Wingfield SA 5013","hours":"Mon-Fri 8:30am-4:30pm"},"WA":{"capital":"Perth, WA","city":"Perth","suburb":"Welshpool, WA","address":"5/54 Kewdale Road, Welshpool WA 6106","hours":"Mon-Fri 8:00am-4:00pm"}};
  var RB_METRO = {"NSW":[[2000,2249],[2555,2574],[2745,2770]],"VIC":[[3000,3207],[3335,3341],[3427,3442],[3750,3810]],"QLD":[[4000,4207],[4208,4287],[4300,4305],[4500,4520]],"SA":[[5000,5199]],"WA":[[6000,6199]]};
  var RB_STATES = {"NSW":[[1000,2599],[2620,2899],[2921,2999]],"VIC":[[3000,3999],[8000,8999]],"QLD":[[4000,4999],[9000,9999]],"SA":[[5000,5999]],"WA":[[6000,6999]]};
  // Sydney first — it is the fallback origin (Tommy: "usually from Sydney if
  // unavailable elsewhere").
  var RB_DISPATCH_ORDER = ['NSW', 'VIC', 'QLD', 'SA', 'WA'];

  function bandLookup(table, postcode) {
    var pc = parseInt(postcode, 10);
    if (!isFinite(pc)) return '';
    for (var code in table) {
      if (!Object.prototype.hasOwnProperty.call(table, code)) continue;
      var bands = table[code];
      for (var i = 0; i < bands.length; i++) {
        if (pc >= bands[i][0] && pc <= bands[i][1]) return code;
      }
    }
    return '';
  }

  // ☠️ The postcode is read from the calculator's RESOLVED address, not from
  // the input box. The input can hold half-typed digits ("40") while the
  // resolved line still says 4000 — and it is the resolved one the rates were
  // actually quoted against. Falls back to the input only if no address has
  // been resolved yet.
  function shopperPostcode() {
    var el = document.querySelector('.oct-calculator-result-address-text');
    var txt = el ? (el.textContent || '') : '';
    var m = txt.match(/\b(\d{4})\b/);
    if (m) return m[1];
    var input = document.querySelector('.oct-calculator-field-zip');
    var v = input ? (input.value || '').trim() : '';
    return /^\d{4}$/.test(v) ? v : '';
  }

  function metroBranchFor(postcode) { return bandLookup(RB_METRO, postcode); }

  // ★★ A325f — WHERE IT ACTUALLY SHIPS FROM (Tommy, 10-08-2026): "if shipping
  // to 4000 for example and Brisbane warehouse is out of stock it would just
  // dispatch from Sydney warehouse, and if only available in WA then it would
  // dispatch from the WA warehouse … usually from Sydney if unavailable
  // elsewhere."
  //   own state -> Sydney -> whoever actually holds it.
  //
  // ☠️ With no postcode this answers ONLY when a single branch holds stock —
  // that case cannot depend on the destination. Otherwise it returns '' and the
  // line renders nothing. The dispatch-origin plan is explicit that a wrong
  // origin is worse than no origin: a Perth buyer told "Sydney" plans around a
  // 10-day rail freight that was never happening.
  function dispatchBranch() {
    var stocked = [];
    for (var i = 0; i < RB_DISPATCH_ORDER.length; i++) {
      if (branchQty(RB_DISPATCH_ORDER[i]) > 0) stocked.push(RB_DISPATCH_ORDER[i]);
    }
    if (!stocked.length) return '';
    if (stocked.length === 1) return stocked[0];
    var pc = shopperPostcode();
    if (!pc) return '';
    var home = bandLookup(RB_STATES, pc);
    if (home && stocked.indexOf(home) >= 0) return home;
    return stocked.indexOf('NSW') >= 0 ? 'NSW' : stocked[0];
  }

  // ☠️☠️ A325d — REPAINT THE ROWS WHEN THE SHOPPER CHANGES VARIANT.
  // Liquid renders the SELECTED variant's figures once, at page load. On a
  // product holding several Federal SKUs — 26 on CE, and on every one of them
  // the branch quantities differ between sizes — picking a different size would
  // otherwise leave the previous size's stock on screen, and could offer a
  // collection that does not exist for the size in the cart.
  //
  // The whole by-variant map rides along in data-rb-wh-map so this needs no
  // second request. Missing variant -> the block hides rather than showing the
  // wrong size's numbers; absence is the honest answer.
  // ☠️ A multi-size product opens on "Choose a variant" and the field's value is
  // the literal string `not-selected` — measured on the Pipe Wallshelf. Treat it
  // as "no variant", not as a key to look up, or the block would stay hidden
  // even after a size is picked because the painted-marker would already match.
  function currentVariantId() {
    var el = document.querySelector('.product-form select[name="id"], .product-form input[name="id"], [name="id"]');
    var v = el ? String(el.value || '') : '';
    return /^\d+$/.test(v) ? v : '';
  }

  function paintWarehouse() {
    var wh = document.querySelector('[data-rb-wh]');
    if (!wh) return;
    var raw = wh.getAttribute('data-rb-wh-map');
    if (!raw) return;
    var map;
    try { map = JSON.parse(raw); } catch (e) { return; }
    var vid = currentVariantId();

    // ☠️☠️ A325e — NOTHING CHOSEN YET means nothing to show. Liquid paints
    // `selected_or_first_available_variant` server-side, so on a multi-size
    // product the page loads showing the FIRST size's stock while the picker
    // still says "Choose a variant" — measured once the card had really run and
    // every variant had figures. A shopper reading "23 in stock" and then
    // picking a size that has none has been misled by a default.
    // ★ Only when a variant field EXISTS and holds no numeric id: on a
    // single-variant product `[name="id"]` is a hidden input carrying the real
    // id, so this branch never fires there.
    var field = document.querySelector('.product-form select[name="id"], .product-form input[name="id"], [name="id"]');
    if (field && !vid) {
      if (!wh.hidden) wh.hidden = true;
      wh.removeAttribute('data-rb-wh-painted');
      return;
    }
    if (!vid || wh.getAttribute('data-rb-wh-painted') === vid) return;
    var qty = map[vid];
    // ☠️☠️ Only ONE variant of a product may be a Federal line. A variant with
    // no entry is not "zero everywhere", it is "we hold no figures for this
    // one" — so the block hides.
    //
    // ...AND THE ROWS MUST BE WIPED, not just hidden. Measured 10-08-2026 on
    // the Pipe Wallshelf: switching 900mm -> 1200mm (no figures) hid the block
    // but left `data-rb-qty="4"` on the Welshpool row, and collectableBranch()
    // reads its quantities straight off those attributes — so the page would
    // have offered a Welshpool collection for a size we hold no stock figures
    // for. Hidden is not the same as absent.
    if (!qty) {
      var stale = wh.querySelectorAll('[data-rb-branch]');
      for (var s = 0; s < stale.length; s++) {
        if (stale[s].getAttribute('data-rb-qty') !== '0') {
          stale[s].setAttribute('data-rb-qty', '0');
        }
      }
      if (!wh.hidden) wh.hidden = true;
      wh.setAttribute('data-rb-wh-painted', vid);
      return;
    }
    if (wh.hidden) wh.hidden = false;
    var rows = wh.querySelectorAll('[data-rb-branch]');
    for (var i = 0; i < rows.length; i++) {
      var code = rows[i].getAttribute('data-rb-branch');
      var n = parseInt(qty[code], 10);
      if (!isFinite(n) || n < 0) n = 0;
      if (rows[i].getAttribute('data-rb-qty') !== String(n)) {
        rows[i].setAttribute('data-rb-qty', String(n));
      }
      // Keep the chip's tint in step with the number it now shows.
      var rowCls = 'rb-wh__row' + (n > 0 ? ' is-stocked' : '');
      if (rows[i].className !== rowCls) rows[i].className = rowCls;
      var cell = rows[i].querySelector('.rb-wh__qty');
      if (!cell) continue;
      // A325h — every branch says its number out loud, including the zeros.
      // The em-dash this replaces was skimmable as "no data"; "0 in stock" is
      // an answer. The RED now lives on the row (`is-stocked` decides it), so
      // the number itself needs no class of its own — see .rb-wh__row.
      setText(cell, n + ' in stock');
    }
    wh.setAttribute('data-rb-wh-painted', vid);
  }

  // The quantities are read back off the rendered rows rather than kept in a
  // second copy of the JSON — one source, and it is the one the shopper can
  // see, so the tile can never disagree with the list above it.
  function branchQty(code) {
    var row = document.querySelector('[data-rb-branch="' + code + '"]');
    if (!row) return 0;
    var n = parseInt(row.getAttribute('data-rb-qty') || '0', 10);
    return isFinite(n) ? n : 0;
  }

  // Returns the branch a collection can be offered from, or '' for none.
  function collectableBranch() {
    var wh = document.querySelector('[data-rb-wh]');
    // ☠️ `hidden` means we hold no figures for the SELECTED variant. Belt to the
    // braces of wiping the rows above — either alone would have been enough,
    // but this one states the rule where the decision is made.
    if (!wh || wh.hidden) return '';                          // no stock data
    var code = metroBranchFor(shopperPostcode());
    if (!code) return '';                                     // not in any metro
    return branchQty(code) > 0 ? code : '';                   // ...and stocked
  }

  // ☠️☠️ A325d — COLLECTION HAS TO BE DISCOVERABLE BEFORE A POSTCODE EXISTS.
  // Tommy, 10-08: "wheres the pickup button/details?" — it was correctly hidden,
  // because without a postcode we cannot know whether he is near a stocked
  // branch. But a shopper who never types a postcode never learns collection is
  // an option at all, and the person who BUILT it thought it was broken.
  //
  // Three states now:
  //   stocked + in that branch's metro -> the real offer, selectable
  //   stocked + no postcode yet        -> a PROMPT: "enter your postcode to
  //                                       check", and clicking it opens the
  //                                       calculator rather than selecting a
  //                                       service we cannot yet offer
  //   no stock anywhere / wrong metro  -> hidden, as before
  function anyBranchHasStock() {
    var wh = document.querySelector('[data-rb-wh]');
    if (!wh || wh.hidden) return false;
    var rows = wh.querySelectorAll('[data-rb-branch]');
    for (var i = 0; i < rows.length; i++) {
      if (parseInt(rows[i].getAttribute('data-rb-qty') || '0', 10) > 0) return true;
    }
    return false;
  }

  // ── A510: THE EXPRESS TILE ──────────────────────────────────────────────
  // ☠️☠️ IT MUST NEVER SHOW WITHOUT A REAL EXPRESS RATE BEHIND IT.
  //
  // The generic tile rule (A335, down in paintTilePrice) shows a tile until the
  // rates come back and prove the service absent. That is right for premium —
  // any supplier might quote it — and wrong here. Only warehouse stock has an
  // express service, so on the ~7,000 dropship products "before a postcode"
  // would be advertising a service that never arrives, on every one of them.
  // Express is therefore driven the other way round: HIDDEN unless an express
  // rate was actually scraped. paintCollect owns its tile for the same reason,
  // and paintTilePrice has to keep its hands off both or the two writers fight
  // over `hidden`.
  //
  // ★ THE NAME COMES FROM THE RATE. The other tiles carry our own wording
  // because the stores disagree about what standard is called ('Kerbside' on CE,
  // 'Door to Door' on CF); express is the opposite case — CE's is Australia
  // Post's own Express Post out of our warehouse, and a vaguer label would throw
  // away the one fact a shopper actually wants. The bracketed transit phrase is
  // stripped off the end because it already prints on the fact line above; the
  // fallback is only reached if a rate arrives with no name at all.
  function paintExpress(panel, data) {
    var tile = panel.querySelector('[data-rb-tile="express"]');
    if (!tile) return false;
    var rate = data.express;
    if (rate) {
      // ☠️ DOUBLE the backslashes — this JS lives inside a non-raw Python
      // string, so each pair below reaches the browser as ONE backslash. Write
      // them singly and Python turns backslash-s into a literal 0x0B, and the
      // regex silently matches nothing. Same trap A344 hit with backslash-b.
      // (Keep bare backslash escapes out of these comments too — Python 3.12
      // raises a SyntaxWarning on every one of them at import.)
      var nm = (rate.name || '').replace(/\s*\([^()]*\)\s*$/, '').trim();
      setText(tile.querySelector('[data-rb-express-name]'), nm || 'Express Delivery');
    }
    var show = !!rate;
    if (tile.hidden === show) tile.hidden = !show;
    return show;
  }

  // ★★ A583 — WHO IS SPEAKING FOR THIS TILE, as a decision on its own.
  //
  // Tommy, 28-08-2026, looking at a Tormek page after A581 put the delivery
  // price back: the collection was correct at the checkout and had vanished
  // from the product page entirely. It had never been on it — paintCollect
  // only ever knew Federal's five branches, out of the warehouse_stock
  // metafield, so our own Brisbane warehouse and Roband's at Cromer had
  // nothing to draw.
  //
  // Four answers, in priority order:
  //   'branch'  RB_BRANCHES named a warehouse from the stock figures — the
  //             existing behaviour, and it WINS, because those figures are
  //             per-branch and per-variant and say more than a rate can.
  //   'rate'    the shipping app returned a collection for this cart. The app
  //             is the authority on its own offer, so the tile shows the rate's
  //             own name and description rather than a second telling of it.
  //   'prompt'  stock exists somewhere but no postcode yet (A325d).
  //   'denied'  a postcode, stock somewhere, but not reachable (A325g).
  //
  // ☠️ 'prompt' and 'denied' stay BELOW 'rate' and are still driven by Federal's
  // stock. For a Tormek there are no branch rows at all, so before a postcode
  // is typed the answer is 'none' and the tile stays hidden — we genuinely do
  // not know whether collection is on offer until the rates come back, and a
  // prompt that says "enter your postcode to check" would be inviting the
  // shopper to check something we cannot answer from a metafield.
  //
  // ★ Pure, and exported on the panel for the tests, because everything else in
  // here needs a DOM and this is the part that decides what a shopper sees.
  function collectSource(branchCode, rate, pc, stocked) {
    if (branchCode) return 'branch';
    if (rate) return 'rate';
    if (!pc && stocked) return 'prompt';
    if (pc && stocked) return 'denied';
    return 'none';
  }
  window.__RB_COLLECT_SOURCE__ = collectSource;

  function paintCollect(panel, data) {
    var tile = panel.querySelector('[data-rb-tile="collect"]');
    if (!tile) return '';
    var code = collectableBranch();
    var b = code ? RB_BRANCHES[code] : null;
    var pc = shopperPostcode();
    var stocked = anyBranchHasStock();
    // The collection the checkout is offering for this cart, if any.
    var rate = (data && data.collect) || null;
    var src = collectSource(code, rate, pc, stocked);
    // ☠️☠️ A325g — DO NOT LET IT VANISH. Tommy, 10-08: "if not available for
    // collection when you enter a postcode it should say — the collection
    // bubble just disappeared." A control that silently deletes itself reads as
    // a fault, not as an answer. Say WHY, in the shopper's terms.
    var prompt = src === 'prompt';
    var denied = src === 'denied';
    var reason = '';
    if (denied) {
      var metro = metroBranchFor(pc);
      reason = metro
        // They CAN drive to a branch — it just has none of this item.
        ? 'No stock at the ' + ((RB_BRANCHES[metro] || {}).city || 'nearest') +
          ' warehouse'
        // They are outside every branch's metro area.
        : 'Not available in your area';
    }

    var qual = tile.querySelector('[data-rb-collect-qual]');
    // ☠️ CSS decides which of the two names and which detail paragraphs are
    // visible; this only says who is speaking. Setting `hidden` here instead
    // would be undone by the [data-rb-detail] loop on the next repaint.
    if (panel.getAttribute('data-rb-csrc') !== src) {
      panel.setAttribute('data-rb-csrc', src);
    }
    if (src === 'rate') {
      // ★ THE APP'S OWN WORDS, LIFTED WHOLE — the name the shopper will pick at
      // the checkout, and the description that goes with it. Not re-worded
      // here: the page and the checkout are then one sentence with one author,
      // and a depot moving needs changing in one place.
      setText(tile.querySelector('[data-rb-collect-ratename]'), rate.name || '');
      setText(qual, '');
      var rd = panel.querySelector('[data-rb-collect-ratedetail]');
      if (rd) setText(rd, rate.desc || '');
    } else if (b) {
      var fields = panel.querySelectorAll('[data-rb-collect]');
      for (var i = 0; i < fields.length; i++) {
        setText(fields[i], b[fields[i].getAttribute('data-rb-collect')] || '');
      }
      // A331 — "From", because next business day is the EARLIEST, not a date.
      // ☠️ Keep this string identical to the Liquid default in the tile markup;
      // they are two writers of one sentence and a drift shows as the wording
      // changing under the shopper the moment a variant is picked.
      setText(qual, 'From next business day, once confirmed');
    }
    if (prompt) {
      // ★ "a warehouse", not a named one — we genuinely do not know which yet,
      // and naming the nearest stocked branch before we know where the shopper
      // is would be a guess dressed as a fact.
      setText(tile.querySelector('[data-rb-collect="capital"]'), 'a warehouse');
      setText(qual, 'Enter your postcode to check');
    } else if (denied) {
      setText(tile.querySelector('[data-rb-collect="capital"]'), 'a warehouse');
      setText(qual, reason);
    }

    // Neither the prompt nor the refusal is a service you can choose, so
    // neither may look chosen.
    var state = (src === 'branch' || src === 'rate')
      ? 'offer' : (prompt ? 'prompt' : (denied ? 'denied' : 'none'));
    if (tile.getAttribute('data-rb-cstate') !== state) {
      tile.setAttribute('data-rb-cstate', state);
    }
    if (tile.getAttribute('data-rb-prompt') !== (prompt ? '1' : '0')) {
      tile.setAttribute('data-rb-prompt', prompt ? '1' : '0');
    }
    var show = state !== 'none';
    if (tile.hidden === show) tile.hidden = !show;
    // ★ TRUTHY WHENEVER THE TILE IS SELECTABLE, not just when a branch was
    // named. The caller only tests truthiness — it drops a 'collect' selection
    // the moment this goes false — so a rate-sourced collection returning the
    // branch code (empty) would have deselected itself on every repaint.
    return src === 'rate' ? 'rate' : code;
  }

  // ── A307l — the price for ONE service, on its own tile ──────────────────
  // Same three states as before, moved to where the shopper chooses:
  //   no rate + nothing known -> nothing at all (never a placeholder)
  //   no rate + rates known    -> "Quote required", greyed, not a price
  //   a rate                   -> the amount, or "Calculated after ordering"
  //                               when it is one of the $0.00 placeholders
  // ★ A392 — RETURNS whether this tile's price came out genuinely free, so the
  // pill by the price can mirror it instead of deciding again. Every exit
  // returns a boolean; a bare `return` would read as `undefined`, which is
  // falsy and would have hidden the pill rather than failing visibly.
  function paintTilePrice(tile, rate, known) {
    var el = tile.querySelector('[data-rb-tprice]');
    if (!el) return false;
    var txt = '', soft = false, free = false;
    if (rate) {
      // ☠️☠️ A ZERO NOW MEANS TWO OPPOSITE THINGS, and telling them apart is the
      // whole job here (A330, 11-08-2026).
      //   * the store's PLACEHOLDER rates are $0.00 — CE codes one `quote`, CF
      //     codes one literally `free-shipping` — and they mean "we have not
      //     priced this yet";
      //   * a Federal FREE METRO DELIVERY is also $0.00, and means free.
      // The old rule was `amount === 0 -> Calculated after ordering`, which was
      // right when every zero was a placeholder. Left alone it would print
      // "Calculated after ordering" over a genuine free delivery — hiding the
      // offer on the page built to sell it, and contradicting checkout.
      // ★ `quoted` is decided by the rate's WORDING (QUOTE_RE), not its amount.
      //
      // ☠️☠️ A333 HOTFIX, 11-08-2026 — THAT WAS NOT ENOUGH, AND IT SHIPPED.
      // Tommy, minutes after publishing: "premium free wtf?" — a $1,243 Polar
      // fridge offered **Premium In-Store Delivery: Free** while Standard was
      // $229.50, on a panel whose own detail line says premium costs "several
      // hundred dollars above kerbside".
      // The premium rate came back $0.00 with an ordinary service NAME, so
      // QUOTE_RE never matched, `quoted` was false, and the zero read as free.
      // I had assumed every placeholder announces itself in words. It does not.
      //
      // ★ THE RULE NOW: a zero may only mean FREE on the STANDARD tile. That is
      // the only service our own free-metro rule can ever zero — it is computed
      // by the Federal kerbside calc, and nothing we run makes premium free.
      // Anywhere else a zero is what it always was: an absence of a price.
      // ★ Whitelist the one case that can legitimately be free, rather than
      // blacklisting the placeholders — the placeholders are the open set.
      // ☠️☠️ A344, 12-08-2026 — AND THAT WAS STILL NOT ENOUGH.
      // Tommy, on a Polar fridge quoting free to 2624: "free delivery to this
      // zone will kill us". The standard tile carries BOTH kinds of zero — the
      // free-metro one AND the quote placeholder — so excluding premium never
      // separated them. What separated them was the WORDING, and on 11-08 we
      // reworded all 59 quote rules to "SHIPPING NOT INCLUDED, invoiced after
      // ordering". QUOTE_RE stopped matching and 1,793 products (41.7% of the
      // catalogue, including a 650 kg $81,704 Williams) began advertising FREE
      // Delivery on freight we then invoice.
      //
      // ★★ THE REAL LESSON, third time of asking: a blacklist of placeholder
      // wordings is an OPEN SET and cannot be completed. Invert it. The app
      // names genuinely-free rates "FREE Kerbside Delivery ..." — engine.js
      // freeName() adds that prefix and is gated on !ruleIsQuote, so a quote
      // rate can never carry the word. That is a CLOSED set of one.
      // ★ So: a zero means free only when the rate NAME says free. Reword the
      // rules again tomorrow and the worst that happens is a placeholder reads
      // "Calculated after ordering" — it can never read as a promise.
      var isStandard = tile.getAttribute('data-rb-tile') === 'standard';
      // ☠️☠️ DOUBLE the backslash. This JS lives inside a NON-RAW Python string,
      // so a single backslash-b compiles to a literal BACKSPACE (0x08) and the
      // deployed regex becomes /<BS>free<BS>/i, which matches nothing. It shipped
      // that way once: every genuine Federal free rate silently fell through to
      // "Calculated after ordering" — the safe direction, so nothing looked
      // broken, and the offer we built the panel to sell had simply vanished.
      // ★ PREM_RE above writes `\s` for exactly this reason. Follow it.
      var saysFree = /\bfree\b/i.test(rate.name || '');
      if (rate.quoted || rate.amount === null) {
        txt = 'Calculated after ordering'; soft = true;
      } else if (rate.amount === 0) {
        // A334 — Tommy, 11-08: "say FREE Delivery not Free" and make it stand
        // out. "Free" alone begs the question free WHAT, sitting under a tile
        // that also mentions a kerb, a loading bay and a dock.
        if (isStandard && saysFree) { txt = 'FREE Delivery'; free = true; }
        else { txt = 'Calculated after ordering'; soft = true; }
      } else if (rate.text) {
        txt = rate.text;
      }
    } else if (known) {
      // A331 — Tommy, 11-08-2026: say WHAT TO DO, not just that a quote is
      // needed. "Quote required" named the obstacle and left the shopper to
      // work out the next move on a panel that has no other call to action.
      // ☠️ The wording matches the button's real label EXACTLY — it reads
      // "Add to quote", lower-case q (see the rb-quote-btn markup). Pointing at
      // a control by the wrong name is worse than not pointing at all.
      // ★ And it points at the BUTTON, never at an email address — the house
      // rule is that the customer requests and WE come back to them.
      txt = 'Quote required — click Add to quote below'; soft = true;
    }

    // ☠️☠️ A335 — if real rates came back and this service was NOT among them,
    // we do not sell it for this product: HIDE the tile rather than inviting a
    // quote for something that does not exist. Roband is the case that proves
    // it — the group has no premium rule at all, so checkout returns kerbside
    // only while the page was still offering "Premium In-Store Delivery".
    // ★ Only once `known` is true. Before a postcode there are no rates to be
    // absent from, and hiding then would blank a tile we are about to show.
    // ★ The collect tile runs its own visibility (paintCollect) — never touch it
    // here, or the two writers fight over `hidden`.
    // ★ A510 — and so does express (paintExpress), which is hidden UNTIL a rate
    // proves it exists rather than shown until one proves it does not.
    var own = tile.getAttribute('data-rb-tile');
    if (own !== 'collect' && own !== 'express') {
      var offered = !(known && !rate);
      if (tile.hidden === offered) tile.hidden = !offered;
    }
    // ☠️ `--free` is ALSO worn by the collect tile's static "No charge" (it is
    // authored in Liquid). Only the earned free-delivery price gets `--freeship`
    // and its pill + pulse, or two green things would compete on one panel.
    var cls = 'rb-tile__price'
      + (soft ? ' rb-tile__price--soft' : '')
      + (free ? ' rb-tile__price--free rb-tile__price--freeship' : '');
    setText(el, txt);
    if (el.className !== cls) el.className = cls;
    if (el.hidden === !!txt) el.hidden = !txt;
    return free;
  }

  // ═══════════════════════════════════════════════════════════════════════
  // A392 — THE FREE DELIVERY PILL, UP BY THE PRICE
  //
  // Tommy, 14-08-2026, holding REO's product page up beside ours: "i like REO's
  // Free delivery icon, can we include something that stands out more on a
  // product if free metro delivery is offered?"
  //
  // ★★ WHAT IT MAY SAY, AND WHEN. Offered three designs, Tommy chose the one
  // that only speaks once the postcode confirms it. So this has NO rule of its
  // own: it is handed `free` from paintTilePrice, which earns that boolean the
  // hard way — the STANDARD tile only, a zero amount, and the rate's own NAME
  // carrying the word "free" (a closed set produced by our shipping app's
  // freeName(), which is gated on !ruleIsQuote).
  //
  // ☠️☠️ THREE TIMES a zero has been read as free on this page and cost us:
  //   A330  every zero meant "not priced yet" until Federal free metro existed
  //   A333  "premium free wtf?" — a $0.00 premium rate with an ordinary name
  //   A344  1,793 products (41.7% of the catalogue, incl. a 650 kg $81,704
  //         Williams) advertised FREE Delivery on freight we then invoiced,
  //         because the quote wordings had been changed underneath the check
  // A pill by the price is the LOUDEST place on the page to be wrong. It is
  // therefore the last thing that should be allowed an opinion.
  //
  // ★ It says "FREE DELIVERY" — not "Free" — because A334 already settled that:
  // "free" alone begs the question free WHAT. The qualifier under it names the
  // service and the postcode the offer was actually quoted against, so nobody
  // reads it as free delivery everywhere.
  //
  // ★ Green, not REO's red. Red on our page already means the sale — the struck
  // RRP and the "Save $1,112.65" badge are both red, and a third red thing by
  // the price would compete with the discount rather than add to it. Green is
  // the colour the tile's own free price already uses, so the pill and the tile
  // read as one claim made twice.
  // ═══════════════════════════════════════════════════════════════════════
  function placeFreePill(free) {
    // ★ It lands in `.rb-priceline` — the wrapper A391 emptied when the
    // ways-to-pay strip moved under the buy row. That wrapper hides itself when
    // empty, so removing the pill restores the closed-up spacing exactly, with
    // no second rule to keep in step.
    var host = document.querySelector('.rb-priceline');
    if (!host) return;
    var pill = host.querySelector('[data-rb-freepill]');
    if (!free) {
      // ☠️ Remove, do not merely hide: `.rb-priceline:empty` is what closes the
      // gap, and `:empty` counts a hidden child as a child.
      if (pill) host.removeChild(pill);
      return;
    }
    // ☠️ ALREADY-IN-PLACE GUARD. The observer wakes on childList records, so
    // creating this node every tick would schedule the next tick forever — the
    // permanent DOM loop setText() and placeStock() both exist to avoid.
    if (!pill) {
      pill = document.createElement('span');
      pill.className = 'rb-freepill';
      pill.setAttribute('data-rb-freepill', '');
      pill.innerHTML =
        '<span class="rb-freepill__ico" aria-hidden="true"></span>'
        + '<span class="rb-freepill__lead">FREE DELIVERY</span>'
        + '<span class="rb-freepill__qual"></span>';
      host.appendChild(pill);
    }
    // ★ The postcode is the RESOLVED one the rates were quoted against, not
    // whatever is half-typed in the box — shopperPostcode() already draws that
    // distinction, and this claim is only as good as the address behind it.
    var pc = shopperPostcode();
    setText(pill.querySelector('.rb-freepill__qual'),
            'Standard kerbside' + (pc ? ' to ' + pc : ''));
  }

  // A587 — what the fact line under the tiles should say for this selection.
  //
  // ★ PURE, and lifted out of paintShip on purpose: paintShip needs a DOM and
  // cannot be run in a test, and the alternative — asserting the source text —
  // proves the line was typed, not that it decides correctly. This is the same
  // move A583 made with collectSource().
  //
  // ☠️☠️ THE COLLECT CASE IS THE WHOLE REASON THIS EXISTS. Tommy, 28-08-2026,
  // on a CE product page: "and you doubling up ... pick the best one, we only
  // show one." Choosing the collect tile printed the app's whole collection
  // sentence here AND the [data-rb-detail="collect"] paragraphs below, which
  // say the same four things at more length and in the theme's own words. The
  // paragraphs win: they are bolded where it matters, they name the SUBURB
  // rather than the street the app's subtitle was still carrying, and every
  // fact in them came from Tommy (10-08).
  //
  // ★ Only collect is special-cased. Standard and Premium have no paragraph of
  // their own repeating the carrier's sentence, so their descriptions still
  // belong here — that is what A307l put them here for.
  //
  // ☠️ A real metafield still wins, exactly as before. `data.eta` is checked
  // first, so a product carrying custom.dispatch_estimate keeps it even while
  // collect is selected: that sentence is ours and is not repeated below.
  function etaFor(sel, data, rate) {
    var d = data || {};
    if (d.eta) return d.eta;
    if (sel === 'collect') return '';
    return (rate && (rate.transit || rate.desc)) || '';
  }

  function setFact(panel, key, value) {
    var el = panel.querySelector('[data-rb-fact="' + key + '"]');
    if (!el) return;
    // Liquid may already have printed one from a metafield; a JS value only
    // overrides when there is a JS value to use.
    if (value) {
      setText(el.querySelector('[data-rb-fact-text]'), value);
      el.hidden = false;
    } else if (!el.getAttribute('data-rb-from-liquid')) {
      el.hidden = true;
    }
  }

  // ── A325c — the "?" toggle ─────────────────────────────────────────────
  // ☠️ CLICK, not hover-only. A hover bubble is unreachable on a phone, and the
  // content it hides includes "Premium does not include stairs" and "don't
  // travel until we confirm". Hover is layered ON TOP for mouse users as a
  // convenience; the click is what makes it work everywhere.
  //
  // ☠️ type="button" and an explicit preventDefault: this whole panel is lifted
  // INSIDE the product <form>, so a stray submit adds to cart.
  // A336 — Tommy, 11-08-2026: "the what's included should be a question mark on
  // each button instead of one under the standard kerbside delivery tab … you
  // wouldn't think it would be the same button for the premium".
  // ☠️ One "?" sitting under the left tile reads as belonging to the left tile,
  // and "Delivery terms" sitting under the right one reads as belonging to
  // Premium. Neither was true: the bubble always described whichever service was
  // SELECTED. Position was making a promise the behaviour did not keep.
  // ★ Each tile now carries its own "?". It is a <span> inside the tile button,
  // never a nested <button> — nesting interactive elements is invalid HTML and
  // strands keyboard users. The click bubbles to the tile (which selects it) and
  // the handler below opens the bubble, so "?" on Premium selects Premium and
  // shows Premium's detail. No new state to keep in step.
  function bindHelp(panel) {
    var body = panel.querySelector('[data-rb-help-body]');
    if (!body || panel.getAttribute('data-rb-helpbound')) return;
    panel.setAttribute('data-rb-helpbound', '1');
    var btn = { getAttribute: function () { return null; }, setAttribute: function () {} };

    function setOpen(open) {
      // ☠️ `!==`, not `===`. The write-only-on-change guard used elsewhere in
      // this file reads `if (el.textContent !== want)`; transcribing it as
      // `if (body.hidden === !open)` inverts it, so opening never assigned and
      // the bubble stayed shut while aria-expanded flipped to "true" — the
      // button said open, the panel was closed, and innerText still returned
      // the hidden text so it LOOKED like it had worked.
      var wantHidden = !open;
      if (body.hidden !== wantHidden) body.hidden = wantHidden;
      var want = open ? 'true' : 'false';
      if (btn.getAttribute('aria-expanded') !== want) {
        btn.setAttribute('aria-expanded', want);
      }
    }
    // Delegated: any tile's "?" opens the bubble. Never closes on a second
    // click of a DIFFERENT tile's mark — you are switching service, not toggling.
    panel.addEventListener('click', function (e) {
      var mark = e.target.closest && e.target.closest('[data-rb-tilehelp]');
      if (!mark) return;
      var tile = mark.closest('[data-rb-tile]');
      var already = !body.hidden;
      var same = tile && tile.getAttribute('aria-checked') === 'true';
      var open = !(already && same);
      setOpen(open);
      if (open) placeHelp(panel, tile);
      // ★ A748 — they have found the "?"; stop the marks beating.
      panel.setAttribute('data-rb-helpseen', '1');
    });
    // A phone turned sideways can move a tile onto a different row.
    window.addEventListener('resize', function () {
      if (!body.hidden) {
        placeHelp(panel, panel.querySelector('[data-rb-tile][aria-checked="true"]'));
      }
    });
  }

  // ★★ A748 — THE BUBBLE OPENS UNDER THE TILE THAT WAS PRESSED (Tommy,
  // 23-09-2026: with a collect tile on the page it opened below that, "almost
  // easy to miss it"). The bubble is MOVED into the tile grid, straight after
  // the last visible tile on the pressed tile's row, where CSS makes it span
  // the whole row — so Standard and Premium, which share a row, open it under
  // that row, and a phone's one-column stack opens it under the tile itself.
  // ☠️ After the last tile ON THE ROW, never directly after the pressed tile:
  // a full-width item placed after Standard would shove Premium onto the next
  // row, and the tiles would rearrange themselves under the shopper's finger.
  // ★ Rows are found by offsetTop, which every tile shares with its row-mates
  // because they have the same offsetParent. Measured with the bubble hidden
  // first, so its own height cannot split a row.
  function placeHelp(panel, tile) {
    var body = panel.querySelector('[data-rb-help-body]');
    var grid = tile && tile.parentNode;
    if (!body || !grid || !grid.classList || !grid.classList.contains('rb-ship__tiles')) return;
    var wasHidden = body.hidden;
    body.hidden = true;
    var top = tile.offsetTop, last = tile;
    var kids = grid.children;
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      if (k === body || k.hidden || !k.hasAttribute('data-rb-tile')) continue;
      if (Math.abs(k.offsetTop - top) < 4) last = k;
    }
    if (last.nextSibling !== body) grid.insertBefore(body, last.nextSibling);
    body.hidden = wasHidden;
    // The caret points at the pressed tile's "?", which sits 7px in from the
    // tile's right edge and is 21px wide: its centre is 17.5px in.
    var tr = tile.getBoundingClientRect(), br = body.getBoundingClientRect();
    if (br.width) {
      body.style.setProperty('--rb-caret', Math.round(tr.right - br.left - 17.5) + 'px');
    }
  }

  function bindShip() {
    var panel = document.querySelector('[data-rb-ship]');
    if (!panel || panel.getAttribute('data-rb-bound')) return;
    bindHelp(panel);
    panel.setAttribute('data-rb-bound', '1');
    if (!panel.getAttribute('data-rb-method')) {
      // ★ Tommy, 08-08-2026: "can't say included, just needs to be the default
      // selected, similar to REO". Standard Kerbside starts chosen.
      panel.setAttribute('data-rb-method', 'standard');
    }
    panel.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-rb-tile]');
      if (!t || !panel.contains(t)) return;
      // ☠️ The panel is lifted INSIDE the <form> by placePanels(), so a stray
      // submit would add to cart. The tiles are type="button" and this is belt
      // and braces on top of that.
      e.preventDefault();
      // ★ A325d — the collect tile in its PROMPT state is not a service you can
      // choose, it is an invitation to give us a postcode. So it does the one
      // useful thing instead: opens the calculator and puts the cursor in the
      // postcode box. Selecting it would show a collection detail for a branch
      // we have not identified.
      // A refusal is not selectable — there is nothing to choose.
      if (t.getAttribute('data-rb-cstate') === 'denied') return;
      if (t.getAttribute('data-rb-prompt') === '1') {
        var opener = document.querySelector('.oct-calculator-open');
        if (opener) opener.click();
        setTimeout(function () {
          var zip = document.querySelector('.oct-calculator-field-zip');
          if (zip) zip.focus();
        }, 350);
        return;
      }
      panel.setAttribute('data-rb-method', t.getAttribute('data-rb-tile'));
      paintShip();
      // A748 — an open bubble follows the chosen tile to its row.
      var ob = panel.querySelector('[data-rb-help-body]');
      if (ob && !ob.hidden) placeHelp(panel, t);
      // ★ "once you click warehouse collection it pops up telling you the
      // actual location" (Tommy, 10-08). Choosing collection is the one case
      // where the detail is the point of the click — the suburb, the
      // next-business-day lead time and the don't-travel-yet warning all live
      // in there. Opening it for them beats making them find the "?".
      if (t.getAttribute('data-rb-tile') === 'collect') {
        var hb = panel.querySelector('[data-rb-help-body]');
        var hbtn = panel.querySelector('[data-rb-tile="collect"] [data-rb-tilehelp]');
        if (hb && hb.hidden) {
          hb.hidden = false;
          if (hbtn) hbtn.setAttribute('aria-expanded', 'true');
          placeHelp(panel, t);
        }
      }
    });
    // Left/right arrows move between tiles, which is what role="radio" promises.
    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var t = e.target.closest && e.target.closest('[data-rb-tile]');
      if (!t) return;
      e.preventDefault();
      // ☠️ A510 — VISIBLE tiles only. This walked every tile in the markup,
      // hidden ones included, so an arrow could select a service that is not on
      // screen. It self-healed for collection (paintShip pushes the selection
      // back to standard), but it was always a keyboard user tabbing into dead
      // stops — and with a third tile that is hidden most of the time, a
      // warehouse product would have offered Premium as an invisible stop
      // between Standard and Express.
      var all = [].slice.call(panel.querySelectorAll('[data-rb-tile]'))
        .filter(function (el) { return !el.hidden; });
      if (!all.length) return;
      var i = all.indexOf(t);
      var next = all[(i + (e.key === 'ArrowRight' ? 1 : all.length - 1)) % all.length];
      panel.setAttribute('data-rb-method', next.getAttribute('data-rb-tile'));
      paintShip();
      next.focus();
    });
    document.addEventListener('rb:ship', paintShip);
  }

  // ── A316: the buy row stacks on MEASURED width, not on a guessed viewport ──
  // ☠️ The old rule was `@media (max-width:600px) { .rb-buyhost > .product-form
  // --atc { ... } }`, which targets a DESCENDANT called .product-form--atc. On
  // CE `.rb-buyhost` IS `.product-form--atc`; on CF `.product-form--atc` is its
  // ANCESTOR. Verified against the rendered HTML of both stores — the selector
  // matched nothing on either, so the 3-track grid survived all the way down to
  // 360px and "Add to quote" spilled out of the page.
  //
  // A viewport media query is the wrong instrument anyway: between roughly 720px
  // and 1230px the product column is HALF the viewport, so a wide screen can
  // still leave the quote button a ~75px track. Measure the row itself.
  // 430px is where a 2:1 split stops leaving the quote button enough for its
  // label (430 - 115 qty - 20 gaps = 295; a third of that is ~98px).
  var sizeRO = null;
  function sizeBuyRow() {
    var row = document.querySelector('.rb-buyhost');
    if (!row) return;
    // Watch the row itself, so a sidebar collapse or a font swap re-runs this
    // even when the viewport never changed. Attached once, on the first row we
    // see; the observer follows the node, not the query.
    if (window.ResizeObserver && !row.getAttribute('data-rb-sized')) {
      row.setAttribute('data-rb-sized', '1');
      if (!sizeRO) sizeRO = new ResizeObserver(function () { sizeBuyRow(); });
      sizeRO.observe(row);
    }
    var w = row.clientWidth;
    if (!w) return;                       // hidden / not laid out yet
    row.classList.toggle('rb-buyhost--stack', w < 430);
  }

  // A307e — the finance boxes. SilverChef is hard-coded in snippets/product.liquid
  // and the SKOPE panel is written there by deploy_skope_funding_panel.py, both
  // BELOW the buy buttons. Rather than fight two other scripts for ownership of
  // that file, move the rendered nodes into the panel at runtime: whoever
  // rewrites product.liquid next, this still finds them.
  // ☠️ Order matters — SKOPE is the featured option and must sit above
  // SilverChef, which is the order they are authored in. appendChild in
  // document order preserves that.
  function fillFinance() {
    var slot = document.querySelector('[data-finance-slot]');
    if (!slot || slot.getAttribute('data-filled')) return;
    // querySelectorAll returns DOCUMENT order, and product.liquid authors SKOPE
    // above SilverChef — so appending in this order keeps the featured option on
    // top without us having to rank them here.
    var boxes = document.querySelectorAll('.skope-funding-panel, .silverchef-panel');
    if (!boxes.length) return;   // nothing to move yet — the wrapper stays hidden
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].parentElement !== slot) slot.appendChild(boxes[i]);
    }
    // Guarded by data-filled: re-running this every observer tick would mutate
    // the DOM on every tick and retrigger the observer forever.
    slot.setAttribute('data-filled', '1');
  }

  // A307h — Add to cart and Add to quote on ONE line (Tommy, 07-08-2026, to
  // match REO).
  //
  // ☠️ The FIRST attempt (06-08) moved the app's own button into a flex row and
  // then lost four rounds trying to centre its label with CSS. The reason it
  // could never be won from here: the RFQ app INJECTS that button at runtime and
  // styles it from its own stylesheet — `snippets/product-form.liquid` doesn't
  // contain it at all. So stop fighting for it.
  //
  // Instead: render OUR OWN button, styled to sit beside Add to cart, and make
  // it a remote control for the app's real button, which we park off-screen.
  // Off-screen and NOT display:none — a hidden button can't always be clicked,
  // and the app needs its own node alive to run its handler.
  function appQuoteBtn() {
    var el = document.querySelector('.omgrfq-btn-quotes');
    if (el) return el;
    var wrap = document.querySelector('.omgrfq-button, .omgrfq-product-button, [class*="omgrfq"]');
    if (wrap) {
      var b = wrap.matches('button, a') ? wrap : wrap.querySelector('button, a');
      if (b) return b;
    }
    // Last resort: match on the label, skipping our own proxy.
    var all = document.querySelectorAll('button, a');
    for (var i = 0; i < all.length; i++) {
      var t = (all[i].textContent || '').trim().toLowerCase();
      if (t === 'add to quote' && !all[i].classList.contains('rb-quote-btn')) return all[i];
    }
    return null;
  }

  function buildBuyRow() {
    // ☠️ Anchor to the Add-to-cart button's OWN PARENT, not to a fixed class.
    // CE puts qty + button directly in `.product-form--atc`; CF nests them a
    // level deeper in `.product-form__action-wrapper` with a <quantity-selector>
    // custom element. Targeting `.product-form--atc` laid the grid out around
    // the wrapper on CF and the buttons never lined up. The cart button's
    // parent is the row on both.
    var cartBtn = document.querySelector('.product-form--atc-button');
    if (!cartBtn || !cartBtn.parentElement) return;
    var atc = cartBtn.parentElement;
    atc.classList.add('rb-buyhost');
    // ☠️ TWO independent steps, each with its own guard. The first cut had one
    // guard on the row: the row got marked on the first pass, BEFORE the RFQ
    // app had injected its button, and from then on the guard returned early
    // every tick — so the quote button was never added at all. The app draws
    // late; this has to keep looking.
    if (atc.querySelector('.rb-quote-btn')) return;   // ours is already in
    // Only offer a quote button if the app actually put one on this product —
    // some products are excluded from the RFQ app, and a dead button is worse
    // than none.
    if (!appQuoteBtn()) return;
    var ours = document.createElement('button');
    ours.type = 'button';   // inside the <form>; must not submit it
    ours.className = 'rb-quote-btn';
    ours.innerHTML =
      '<svg class="rb-quote-btn__ico" width="17" height="17" viewBox="0 0 24 24" ' +
      'fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" ' +
      'stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>' +
      '<polyline points="14 2 14 8 20 8"></polyline>' +
      '<line x1="16" y1="13" x2="8" y2="13"></line>' +
      '<line x1="16" y1="17" x2="8" y2="17"></line></svg><span>Add to quote</span>';
    ours.addEventListener('click', function (e) {
      e.preventDefault();
      // ☠️ Re-query at CLICK time. The app redraws its own block, so a node
      // captured at build time goes stale and the button silently stops working.
      var real = appQuoteBtn();
      if (real) real.click();
    });
    // ☠️ Append INSIDE .product-form--atc, not into .rb-buyhost. Only as a
    // SIBLING of the real Add-to-cart button can the two share one flex context
    // — which is what makes an exact 2:1 width split and an identical height
    // possible at all. As cousins in different containers, neither is.
    atc.appendChild(ours);
    document.documentElement.classList.add('rb-has-quote');
  }

  function tick() {
    placeSwitch();
    placePanels();
    placeStock();
    placePriceRow();
    fillPanel();
    fillFinance();
    buildBuyRow();
    bindShip();
    paintShip();
    sizeBuyRow();
    convert();
  }

  function boot() {
    tick();
    // Variant switches, quick-view and infinite scroll all rewrite prices — and
    // the shipping calculator draws its rate rows long after load, which is what
    // gives the compact line a price to show.
    if (window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(tick, 60);
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    // ☠️ Width, not viewport. A rotate or a sidebar collapse changes the row's
    // own width without changing anything a media query can see.
    var rz = null;
    window.addEventListener('resize', function () {
      clearTimeout(rz);
      rz = setTimeout(sizeBuyRow, 120);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
